import React, { useEffect, useState, useContext } from 'react'
import useTranslate from '../hooks/useTranslate';
import { Link } from 'react-router-dom'
import { FaStar } from 'react-icons/fa'
import Context from '../context'

const RecentlyViewed = () => {
    const { translateText, languageCode } = useContext(Context)
    const t = useTranslate({
        recently: "Recently",
        viewed: "Viewed",
        clearHistory: "Clear History",
        productLabel: "Product"
    });
    const [recentProducts, setRecentProducts] = useState([])
    const [translatedProducts, setTranslatedProducts] = useState([])

    useEffect(() => {
        const stored = localStorage.getItem('recentlyViewed')
        if (stored) {
            const parsed = JSON.parse(stored).reverse();
            setRecentProducts(parsed)
            setTranslatedProducts(parsed)
        }
    }, [])

    useEffect(() => {
        const translateData = async () => {
            if (!languageCode || languageCode === 'en' || recentProducts.length === 0) {
                setTranslatedProducts(recentProducts);
                return;
            }

            try {
                const translated = await Promise.all(
                    recentProducts.map(async (prod) => ({
                        ...prod,
                        productName: await translateText(prod.productName || prod.itemname, languageCode),
                        category: await translateText(prod.category, languageCode)
                    }))
                );
                setTranslatedProducts(translated);
            } catch (error) {
                console.error("Error translating recently viewed:", error);
            }
        };

        translateData();
    }, [languageCode, translateText, recentProducts]);

    if (recentProducts.length === 0) return null

    return (
        <div className='container mx-auto px-4 my-6 relative'>
            {/* Unified Premium Heading */}
            <div className='flex items-center justify-between mb-4'>
                <h2 className='text-xl md:text-2xl font-black text-slate-800 uppercase tracking-tight flex items-center gap-2'>
                    {t.recently} <span className='text-orange-500'>{t.viewed}</span>
                </h2>
                <button
                    onClick={() => {
                        localStorage.removeItem('recentlyViewed')
                        setRecentProducts([])
                    }}
                    className='text-[11px] font-black text-slate-400 hover:text-red-500 transition-all uppercase tracking-widest border border-slate-100 px-5 py-2 rounded-full hover:bg-red-50 shadow-sm'
                >
                    {t.clearHistory}
                </button>
            </div>

            <div className='flex items-center gap-5 overflow-x-auto scrollbar-none pb-6 px-1'>
                {Array.isArray(translatedProducts) && translatedProducts.map((product, index) => {
                    const price = product?.sellingPrice || product?.price || 0;
                    return (
                        <div
                            key={product?._id + index}
                            className='min-w-[200px] md:min-w-[220px] bg-white rounded-[1.5rem] flex flex-col group/card relative overflow-hidden border border-slate-100 shadow-[0_4px_15px_-3px_rgba(0,0,0,0.05)] hover:shadow-[0_20px_35px_-10px_rgba(0,0,0,0.1)]'
                        >
                            {/* Image Area */}
                            <Link to={"/product/" + product?._id} className='h-[160px] p-6 flex justify-center items-center overflow-hidden bg-slate-50/30 relative'>
                                <img
                                    src={product?.productImage?.[0] || product?.image?.[0] || 'https://placehold.co/400x400/eaeff6/2a4b7c?text=FasalShop'}
                                    className='object-contain h-full w-full group-hover/card:scale-105 transition-transform duration-500 ease-out z-10'
                                    alt={product?.productName || t.productLabel}
                                />
                                <div className='absolute inset-0 bg-black/[0.02] opacity-0 group-hover/card:opacity-100 transition-opacity'></div>
                            </Link>

                            {/* Content Area */}
                            <div className='p-5 flex flex-col flex-grow'>
                                <span className='text-[9px] font-black text-[#00b259] uppercase tracking-widest mb-1'>{product?.category}</span>
                                <Link to={"/product/" + product?._id} className='flex-grow'>
                                    <h3 className='text-sm font-black text-slate-800 line-clamp-1 group-hover/card:text-[#00b259] transition-colors uppercase tracking-tight mb-3'>
                                        {product?.productName}
                                    </h3>
                                </Link>

                                <div className='flex items-center justify-between mt-auto'>
                                    <span className='text-slate-900 font-black text-lg'>₹{price}</span>
                                    <div className='bg-[#00b259]/10 text-[#00b259] px-2 py-0.5 rounded text-[10px] font-black flex items-center gap-1'>
                                        {product?.rating || '5.0'} <FaStar size={8} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    )
}


export default RecentlyViewed
